import type { HasIPenTeamsChannels } from '@ipen-portal/plugin-common';
import type { FC } from 'react';

import { Link as Url } from '@backstage/core-components';
import { Icon } from '@iconify/react';
import { colors } from '@ipen/components';
import {
  Divider,
  IconButton,
  Link,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { Fragment } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  divider: {
    backgroundColor: theme.palette.divider,
    height: 2,
    marginLeft: 54,
  },
  launchIcon: {
    color: theme.palette.common.black,
  },
  link: {
    ...theme.typography.link,
  },
  reactBeforeIcon: {
    height: 32,
    marginLeft: -12,
    marginRight: 12,
    width: 32,
  },
  secondary: {
    color: colors.eonNeutral.color700,
    textTransform: 'capitalize',
  },
}));

type teamsChannelProps = {
  teamsChannel: HasIPenTeamsChannels | undefined;
};

export const TeamsChannelComponent: FC<teamsChannelProps> = ({
  teamsChannel,
}) => {
  const teamsChannels = teamsChannel?.spec.teamsChannels ?? [];
  const { classes } = useStyles();

  return (
    <>
      {teamsChannels.map(channel => (
        <Fragment key={channel.title}>
          <ListItem aria-label="MS Teams">
            <Icon
              className={classes.reactBeforeIcon}
              icon="bi:microsoft-teams"
            />
            <ListItemText
              primary={(
                <Typography variant="body1">
                  <Link className={classes.link} href={channel.url}>
                    {channel?.title}
                  </Link>
                </Typography>
              )}
              secondary={(
                <Typography variant="body1">
                  <span className={classes.secondary}>MS Teams</span>
                </Typography>
              )}
            />
            <IconButton
              aria-label="Link"
              component={Url}
              role="button"
              to={channel.url}
            >
              <Icon
                className={classes.launchIcon}
                icon="material-symbols:open-in-new"
              />
            </IconButton>
          </ListItem>
          <Divider className={classes.divider} />
        </Fragment>
      ))}
    </>
  );
};
